export enum EntityName {
    Coupon = 'Coupon',
    Division = 'Division',
    DivisionDiscount = 'DivisionDiscount',
    Product = 'Product',
    Wrestler = 'Wrestler',
}
